var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-return-edit-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Review customer details and address\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n    Review and edit the customer details to make sure all info is correct.\n  "
        ),
      ]),
      _vm._v(" "),
      !_vm.customerUIState.authorized && _vm.customerUIState.valid
        ? _c("el-alert", {
            attrs: {
              closable: false,
              title: _vm.findAlertByKey("customerAuthorizationRequired").title,
              type: "warning",
              description: _vm.findAlertByKey("customerAuthorizationRequired")
                .description,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.customerUIState.valid
        ? _c("el-alert", {
            attrs: {
              closable: false,
              title: _vm.findAlertByKey("customerEmailNotFound").title,
              type: "warning",
              description: _vm.findAlertByKey("customerEmailNotFound")
                .description,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "edit-customer-details" }, [
        _c("div", { staticClass: "flex flex-col gap_s" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-16" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editedCustomer.first_name,
                  expression: "editedCustomer.first_name",
                },
              ],
              staticClass: "flex-1 input-field",
              staticStyle: { height: "48px" },
              domProps: { value: _vm.editedCustomer.first_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.editedCustomer,
                    "first_name",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editedCustomer.last_name,
                  expression: "editedCustomer.last_name",
                },
              ],
              staticClass: "flex-1 input-field",
              staticStyle: { height: "48px" },
              domProps: { value: _vm.editedCustomer.last_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.editedCustomer, "last_name", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.first_name || _vm.errors.last_name
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.first_name) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.last_name) + "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editedCustomer.email,
                    expression: "editedCustomer.email",
                  },
                ],
                staticClass: "flex-1 input-field",
                staticStyle: { height: "48px" },
                domProps: { value: _vm.editedCustomer.email },
                on: {
                  blur: _vm.onBlur,
                  mouseleave: _vm.onMouseLeave,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editedCustomer, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "vue-tel-input",
                {
                  key: _vm.country_code,
                  staticClass: "flex-1 input-field",
                  staticStyle: { height: "48px" },
                  attrs: {
                    "default-country": _vm.country_code,
                    mode: "international",
                  },
                  on: {
                    "country-changed": _vm.updatePhone,
                    validate: _vm.updatePhoneValidation,
                  },
                  model: {
                    value: _vm.editedCustomer.phone_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.editedCustomer, "phone_number", $$v)
                    },
                    expression: "editedCustomer.phone_number",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-arrow-down",
                    attrs: { slot: "arrow-icon" },
                    slot: "arrow-icon",
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.email || _vm.errors.phone_number
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.email) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.phone_number) +
                      "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "edit-customer-details" }, [
        _c("div", { staticClass: "flex flex-col gap_s" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "google-places",
                    rawName: "v-google-places",
                    value: _vm.googleOn,
                    expression: "googleOn",
                  },
                ],
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                on: { selected: _vm.placeSelected },
                model: {
                  value: _vm.editedAddress.address1,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "address1", $$v)
                  },
                  expression: "editedAddress.address1",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-16" }, [
            _vm.errors.address1
              ? _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.address1) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("el-input", {
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                model: {
                  value: _vm.editedAddress.address2,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "address2", $$v)
                  },
                  expression: "editedAddress.address2",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-16" }, [
            _vm.errors.address2
              ? _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.address2) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("country-input", {
                staticClass: "flex-1 select-field",
                attrs: { value: _vm.country_code },
                model: {
                  value: _vm.country_code,
                  callback: function ($$v) {
                    _vm.country_code = $$v
                  },
                  expression: "country_code",
                },
              }),
              _vm._v(" "),
              _c("country-state-input", {
                staticClass: "flex-1 select-field",
                attrs: { "input-type": "select", country: _vm.country_code },
                model: {
                  value: _vm.state_code,
                  callback: function ($$v) {
                    _vm.state_code = $$v
                  },
                  expression: "state_code",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.country || _vm.errors.state
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.country) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.state) + "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("el-input", {
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                model: {
                  value: _vm.editedAddress.city,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "city", $$v)
                  },
                  expression: "editedAddress.city",
                },
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                model: {
                  value: _vm.editedAddress.zip_code,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "zip_code", $$v)
                  },
                  expression: "editedAddress.zip_code",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.city || _vm.errors.zip_code
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.city) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.zip_code) + "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _vm._v("\n      Customer details\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          First Name\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Last Name\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Email\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Phone Number\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "16px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _vm._v("\n      Address\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Address Line 1\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Address Line 2\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Country\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          State\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          City\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Zip code\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }